/**
 * Case à cocher étiquetée (consentements CGU / confidentialité).
 *
 * La zone cliquable est l’ensemble « case + libellé » : sur téléphone, viser une case de 16 px
 * serait irréaliste. Le libellé reste un vrai `<label>` lié par `htmlFor`.
 */
import type { InputHTMLAttributes } from 'react';

export interface ProprietesCaseACocher extends Omit<InputHTMLAttributes<HTMLInputElement>, 'id' | 'type'> {
  readonly id: string;
  readonly libelle: string;
  readonly erreur?: string | null;
}

export function CaseACocher({ id, libelle, erreur, className, ...reste }: ProprietesCaseACocher) {
  const idErreur = erreur === null || erreur === undefined ? null : `${id}-erreur`;
  const classes = ['case', className].filter(Boolean).join(' ');
  return (
    <div className={classes}>
      <label className="case__etiquette" htmlFor={id}>
        <input
          {...reste}
          id={id}
          type="checkbox"
          className="case__saisie"
          aria-invalid={idErreur === null ? undefined : true}
          aria-describedby={idErreur === null ? undefined : idErreur}
        />
        <span className="case__libelle">{libelle}</span>
      </label>
      {idErreur === null ? null : (
        <p className="champ__erreur" id={idErreur} role="alert">
          {erreur}
        </p>
      )}
    </div>
  );
}
